export default "__VITE_ASSET__C7k2aIYn__"